import { SearchTrigger } from '@main/context/orchestrator.ts'
import OverlayIpcRenderer from '@renderer/ipc/OverlayIpc.renderer.ts'
import { useCallback } from 'react'

export const useRequestContext = () => {
  return useCallback(async (searchTrigger: SearchTrigger) => {
    return await OverlayIpcRenderer.requestContext({
      requestType: 'default',
      searchTrigger,
    })
  }, [])
}
